import type { LucideIcon } from 'lucide-react';
import { Clock, FileText, MessageCircleMore, Phone, ShieldCheck, Sparkles, UserRoundPlus, Users } from 'lucide-react';
import type { OnboardingStepId } from './onboarding-checklist-storage';

/** אייקון וקטורי לכל שלב — לווידג'ט האונבורדינג בלבד */
export const ONBOARDING_STEP_LUCIDE_ICON: Record<OnboardingStepId, LucideIcon> = {
  accountSetup: ShieldCheck,
  whatsapp: Phone,
  firstConversation: MessageCircleMore,
  company: Clock,
  geminiAi: Sparkles,
  users: Users,
  contacts: UserRoundPlus,
  template: FileText,
};
